import { render, staticRenderFns } from "./EnterName.vue?vue&type=template&id=3787748c&scoped=true&"
import script from "./EnterName.vue?vue&type=script&lang=js&"
export * from "./EnterName.vue?vue&type=script&lang=js&"
import style0 from "./EnterName.vue?vue&type=style&index=0&id=3787748c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3787748c",
  null
  
)

export default component.exports